// This must be imported as a module
// <script type="module" crossorigin src="auth-client.ts"></script> 

// @ts-ignore
import authClientFr from "./views/auth-client-fr.html?raw"
// @ts-ignore
import authClientEn from "./views/auth-client-en.html?raw"

import "./views/auth-client.css"
// import "./webflow.css"
// import "./general_webflow.css"

import { authService } from "./services/auth.service"
import { SignInView } from "./views/sign-in-view"
import { i18n } from "./services/i18n.service"

import { OTPDiag } from "./views/otp.view"
import { webFlowService } from './services/web-flow.service'
import { later, setVisible } from "./helpers"

const AUTH_CONTAINER = 'navbarV3LoginPlaceholderEl'
const AUTH_ELEM_CLASS = 'privy_components_placeholder'
const SHOW_NEW_USER_MS = 2500
const DIALOG_AUTO_CLOSE_TIMEOUT = 2500

document.addEventListener('DOMContentLoaded', async () => {
  // inner State
  // we get this info from auth check or sign in dialog response
  let existingUser = false
  // auto close dialog after 2.5s
  let autoCloseIntervalID: number | undefined

  // elements to hide when user is authenticated
  const pageAuthElements = Array.from(document.querySelectorAll<HTMLElement>(`.${AUTH_ELEM_CLASS}`))

  const authElem = document.getElementById(AUTH_CONTAINER)
  if (!authElem) { throw new Error('Auth Element not found :\'(') }
  authElem.innerHTML = i18n.getLanguage() === 'en' ? authClientEn : authClientFr

  const showOTPDialog = (email: string) => { otpDiagView.open(email) }

  const signInContainer = authElem.querySelector<HTMLDialogElement>("#sign-in-container")
  const OTPSendContainer = authElem.querySelector<HTMLDialogElement>("#otp-send-container")
  const newUserContainer = authElem.querySelector<HTMLDialogElement>('.auth-wrapper.new-user')
  const connectBtn = authElem.querySelector<HTMLButtonElement>('button.sign-btn')

  // Ensure DOM is valid
  const isContainer = (e: any) => e instanceof HTMLDialogElement
  const isButton = (e: any) => e instanceof HTMLButtonElement
  const requiredContainers = [OTPSendContainer, signInContainer, newUserContainer]
  if (!requiredContainers.every(isContainer) || !(isButton(connectBtn))) {
    throw new Error('missing elements')
  }

  const setPageAuthVisible = (visible: boolean) => pageAuthElements.forEach(e => setVisible(e, visible))
  const updateConnectionBtn = (authenticated: boolean) => {
    const label = authenticated ? 'logout' : 'login'
    const clickHandlerToRemove = authenticated ? loginButtonClick : logoutButtonClick
    const clickHandlerToAdd = authenticated ? logoutButtonClick : loginButtonClick
    connectBtn.innerText = i18n.t(label)
    connectBtn.removeEventListener('click', clickHandlerToRemove)
    connectBtn.addEventListener('click', clickHandlerToAdd)
  }

  const updateAuthView = async (authenticated: boolean) => {
    updateConnectionBtn(authenticated)
    setPageAuthVisible(!authenticated)
  }

  const onEmailSent = async (email: string, existingUserResponse: boolean) => {
    existingUser = existingUserResponse
    showOTPDialog(email)
  }

  const handleOTPValidatedAndClosed = async (e: Event) => {
    clearInterval(autoCloseIntervalID)

    if (!existingUser) {
      newUserContainer?.showModal()
      await later(SHOW_NEW_USER_MS)
      newUserContainer?.close()
    }

    updateAuthView(authService.isAuthenticated)
    await checkLoginState()
    webFlowService.onLogin(authService.authInfos)
  }

  const onOTPConfirmed = async () => {
    OTPSendContainer.addEventListener('close', handleOTPValidatedAndClosed, { once: true })
    autoCloseIntervalID = setTimeout(function () { otpDiagView.close() }, DIALOG_AUTO_CLOSE_TIMEOUT)
  }

  const signInView = new SignInView(signInContainer, onEmailSent)
  const otpDiagView = new OTPDiag(OTPSendContainer, onOTPConfirmed)

  const logout = () => {
    authService.logout()
    updateAuthView(false)
    webFlowService.onLogout() // @note triggers page reload
  }

  const login = () => {
    existingUser = false
    signInView.open()
  }

  const checkLoginState = async () => {
    await authService.checkAuth()
    const authenticated = authService.isAuthenticated
    updateAuthView(authenticated)
    if (authenticated) { webFlowService.onLogin(authService.authInfos) }
  }

  const logoutButtonClick = (_event: MouseEvent) => logout()
  const loginButtonClick = (_event: MouseEvent) => login()

  checkLoginState()
})